import type { Timeseries } from '@cognite/sdk';

export const yLabel = (point: any, timeseries: Timeseries[]) => {
  const timeserie = timeseries.find((ts) => point.name === ts.name);
  const unit = timeserie && timeserie.unit ? timeserie.unit : '';
  return `${Number.parseFloat(point.value).toFixed(3)} ${unit}`;
};
